import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/lib/auth";
import PublicLayout from "@/components/PublicLayout";
import AdminLayout from "@/components/AdminLayout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Products from "@/pages/Products";
import About from "@/pages/About";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import Team from "@/pages/Team";

import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminSite from "@/pages/AdminSite";
import AdminServices from "@/pages/AdminServices";
import AdminProducts from "@/pages/AdminProducts";
import AdminTeam from "@/pages/AdminTeam";
import AdminJobs from "@/pages/AdminJobs";
import AdminApplications from "@/pages/AdminApplications";
import AdminMessages from "@/pages/AdminMessages";
import AdminApiLogin from "@/pages/AdminApiLogin";

const Public = ({ children }) => <PublicLayout>{children}</PublicLayout>;
const Admin = ({ children }) => (
  <ProtectedRoute>
    <AdminLayout>{children}</AdminLayout>
  </ProtectedRoute>
);

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Public><Home /></Public>} />
            <Route path="/services" element={<Public><Services /></Public>} />
            <Route path="/products" element={<Public><Products /></Public>} />
            <Route path="/about" element={<Public><About /></Public>} />
            <Route path="/team" element={<Public><Team /></Public>} />
            <Route path="/careers" element={<Public><Careers /></Public>} />
            <Route path="/contact" element={<Public><Contact /></Public>} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin><AdminDashboard /></Admin>} />
            <Route path="/admin/site" element={<Admin><AdminSite /></Admin>} />
            <Route path="/admin/services" element={<Admin><AdminServices /></Admin>} />
            <Route path="/admin/products" element={<Admin><AdminProducts /></Admin>} />
            <Route path="/admin/team" element={<Admin><AdminTeam /></Admin>} />
            <Route path="/admin/jobs" element={<Admin><AdminJobs /></Admin>} />
            <Route path="/admin/applications" element={<Admin><AdminApplications /></Admin>} />
            <Route path="/admin/messages" element={<Admin><AdminMessages /></Admin>} />
            <Route path="/admin/api-login" element={<Admin><AdminApiLogin /></Admin>} />

            <Route path="*" element={<Public><Home /></Public>} />
          </Routes>
          <Toaster position="top-right" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
